export const COLOR_NAVY_BLUE = '#1b3550';
export const COLOR_YELLOW = '#ffb300';
export const COLOR_CYAN = '#1dc3a4';

export const COLOR_DATA_VIS_1 = COLOR_NAVY_BLUE;
export const COLOR_DATA_VIS_2 = '#464372';
export const COLOR_DATA_VIS_3 = '#834a85';
export const COLOR_DATA_VIS_4 = '#c04e81';
export const COLOR_DATA_VIS_5 = '#ef5d69';
export const COLOR_DATA_VIS_6 = '#ff8243';
export const COLOR_DATA_VIS_7 = COLOR_YELLOW;
export const COLOR_DATA_VIS_8 = '#3283f8';
export const COLOR_DATA_VIS_9 = '#00CBE0';
export const COLOR_DATA_VIS_10 = '#69DB56';
export const COLOR_DATA_VIS_11 = '#691cb5';
export const COLOR_DATA_VIS_12 = '#98fb98';
export const COLOR_DATA_VIS_13 = '#ffee93';
